"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_styles_1 = require("./Button.styles");
var Button = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, onClick = _a.onClick, _c = _a.className, className = _c === void 0 ? "" : _c;
    var styles = (0, Button_styles_1.useStyles)();
    return ((0, jsx_runtime_1.jsx)("button", __assign({ className: "".concat(styles[variant], " ").concat(className), onClick: onClick }, { children: children })));
};
exports.default = Button;
